import { Link } from 'react-router-dom';
import styles from './index.module.sass';

const Button = ({ to = '', onClick, children, disabled = false }) => {
  if (to) {
    return (
      <Link to={to} onClick={onClick} className={styles.button}>
        {children}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={styles.button} disabled={disabled}>
      {children}
    </button>
  );
};

export default Button;
